import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import Header from "./components/ui/Header";
import ProtectedRoute from "./components/ProtectedRoute";

import NotFound from "./pages/NotFound";
import Login from "./pages/auth/Login";
import Signup from "./pages/auth/Signup";
import Dashboard from "./pages/Dashboard";
import UserManagement from "./pages/UserManagement";
import ManualReviewInterface from './pages/manual-review-interface';
import ProcessingStatusMonitor from './pages/processing-status-monitor';
import ResultsDashboard from './pages/results-dashboard';
import FileUploadDashboard from './pages/file-upload-dashboard';
import ColumnMappingInterface from './pages/column-mapping-interface';
import ExportAndReportsCenter from './pages/export-and-reports-center';
import AIDashboard from './pages/ai-dashboard';
import UserProfileSettingsCenter from './pages/user-profile-settings-center';
import PlatformAdminDashboard from './pages/platform-admin-dashboard';
import CompanyCreationInterface from './pages/company-creation-interface';
import SystemManagementConsole from './pages/system-management-console';
import { AuthProvider } from './contexts/AuthContext';

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <AuthProvider>
          <Header />
          <ScrollToTop />
          <RouterRoutes>
            {/* Public Authentication Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            
            {/* Protected Application Routes */}
            <Route path="/" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/user-management" element={
              <ProtectedRoute>
                <UserManagement />
              </ProtectedRoute>
            } />
            
            {/* Protected User Profile & Settings */}
            <Route path="/user-profile-settings-center" element={
              <ProtectedRoute>
                <UserProfileSettingsCenter />
              </ProtectedRoute>
            } />
            
            {/* Protected Application Routes */}
            <Route path="/manual-review-interface" element={
              <ProtectedRoute>
                <ManualReviewInterface />
              </ProtectedRoute>
            } />
            <Route path="/processing-status-monitor" element={
              <ProtectedRoute>
                <ProcessingStatusMonitor />
              </ProtectedRoute>
            } />
            <Route path="/results-dashboard" element={
              <ProtectedRoute>
                <ResultsDashboard />
              </ProtectedRoute>
            } />
            <Route path="/file-upload-dashboard" element={
              <ProtectedRoute>
                <FileUploadDashboard />
              </ProtectedRoute>
            } />
            <Route path="/column-mapping-interface" element={
              <ProtectedRoute>
                <ColumnMappingInterface />
              </ProtectedRoute>
            } />
            <Route path="/export-and-reports-center" element={
              <ProtectedRoute>
                <ExportAndReportsCenter />
              </ProtectedRoute>
            } />
            <Route path="/ai-dashboard" element={
              <ProtectedRoute>
                <AIDashboard />
              </ProtectedRoute>
            } />
            
            <Route path="/platform-admin-dashboard" element={
              <ProtectedRoute>
                <PlatformAdminDashboard />
              </ProtectedRoute>
            } />
            <Route path="/company-creation-interface" element={
              <ProtectedRoute>
                <CompanyCreationInterface />
              </ProtectedRoute>
            } />
            
            <Route path="/system-management-console" element={
              <ProtectedRoute>
                <SystemManagementConsole />
              </ProtectedRoute>
            } />
            
            {/* 404 Route */}
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </AuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
}